export default __webpack_public_path__ + "static/media/back_b.b8b17069.jpg";